import axios from 'axios';

import authHeader from './auth-header';
const API_URL = process.env.VUE_APP_API_URL;

class DOService {

  listClient() {
    return axios.get(API_URL + 'client/list',{ headers: authHeader() });
  }

  listProvince() {
    return axios.get(API_URL + 'area/provinces',{ headers: authHeader() });
  }


  listCity() {
    return axios.get(API_URL + 'area/cities',{ headers: authHeader() });
  }

  getDO(param) {
    /*
    if (!param.client_id && !param.status && !param.printed) {
      //Always limit
      return axios.get(API_URL + 'do/list',{ params: {limit: param.limit},headers: authHeader() });
    } else {
      if  (param.status === 1) {
        param.status = 0
      }
      console.log('FAK')
      return axios.get(API_URL + 'do/list',{  params: param, headers: authHeader() });
    }
     */
    return axios.get(API_URL + 'do/list',{  params: param, headers: authHeader() });
  }

  searchDO(ref) {
    return axios.get(API_URL + 'do/list',{ params: { search: ref }, headers: authHeader() });
  }

  getPicklist(doList) {
    return axios
        .post(API_URL + 'pick/list/generate',
            doList,
            { headers: authHeader() }
            );
  }

  /*async*/ singleAllocate(doId,errHandle) {
    return /*await*/ axios
        .post(API_URL + 'pick/allocate/gi',
            [doId],
            { headers: authHeader() }
        ).catch(
            function(err) {
              errHandle(err, doId)
            }
        );
  }

  singleGI(doId,errHandle) {
    return /*await*/ axios
        .post(API_URL + 'pick/confirm/gi',
            [doId],
            { headers: authHeader() }
        ).catch(
            function(err) {
              errHandle(err, doId)
            }
        );
  }

  bulkAllocate(doIds,  errHandle) {
    let callList = []
    for(let iii = 0; iii < doIds.length; iii++) {
      callList.push( this.singleAllocate( doIds[iii] , errHandle) )
    }
    return axios.all(callList)
  }

  bulkGI(doIds,  errHandle) {
    let callList = []
    for(let iii = 0; iii < doIds.length; iii++) {
      callList.push( this.singleGI( doIds[iii] , errHandle) )
    }
    return axios.all(callList)
  }

}

export default new DOService();
